<template>
	<StoryblokComponent
		v-for="blok in appStore.topBar"
		:key="blok._uid"
		:blok="blok"
	/>
	<div :class="{ 'border-b border-b-gray-lighter': pageType != 'home' }">
		<header class="main-wrapper">
			<!-- For Desktop -->
			<div class="header-desktop hidden lg:block">
				<LayoutHeaderDesktop
					v-if="appStore.headerLoaded"
					:search="appStore.search"
					:site-logo="appStore.siteLogo"
					:site-logo-dimensions="appStore.siteLogoDimensions"
					:menu-categories-norce="appStore.menuCategoriesNorce"
					:menu-categories="appStore.menuCategories"
				/>
			</div>
			<!-- For Mobile -->
			<div class="header-mobile block lg:hidden container mx-auto">
				<LayoutHeaderMobile
					v-if="appStore.headerLoaded"
					:cultures-norce="appStore.culturesNorce"
					:currencies-norce="appStore.currenciesNorce"
					:search="appStore.search"
					:site-logo="appStore.siteLogo"
					:site-logo-dimensions="appStore.siteLogoDimensions"
					:menu-categories-norce="appStore.menuCategoriesNorce"
					:menu-categories="appStore.menuCategories"
				/>
			</div>
			<!-- Loading Spinner -->
			<div v-if="!appStore.headerLoaded" class="loader"></div>
		</header>
	</div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { storeToRefs } from "pinia";

const { pageType } = storeToRefs(usePageStore());
const cartStore = useCartStore();
const appStore = useAppStore();

watch(
	() => cartStore.cartId,
	(newCartId) => {
		if (newCartId) {
			cartStore.initCart();
		}
	},
	{ immediate: true }
);

watch(
	() => cartStore.updated,
	(newUpdated) => {
		if (newUpdated) {
			cartStore.initCart();
		}
	},
	{ immediate: true }
);
</script>
